import { masterAccountBoardErrorReason } from '@/utils/master-account-board-error';
import { useFeatureTranslation } from './useFeatureTranslation';

/**
 * The translated message for a refusal of the master account board or of the master account's own books, or
 * `undefined` for any other error — the caller shows its own message for those.
 */
export function useMasterAccountBoardErrorMessage(): (error: unknown) => string | undefined {
  const t = useFeatureTranslation('masterAccountBoardShell.errors');
  return error => {
    const reason = masterAccountBoardErrorReason(error);
    return reason ? t(reason) : undefined;
  };
}
